var Displaying = /* @__PURE__ */ ((Displaying2) => {
  Displaying2["inherit"] = "inherit";
  Displaying2["initial"] = "initial";
  Displaying2["inline"] = "inline";
  Displaying2["flex"] = "flex";
  Displaying2["block"] = "block";
  Displaying2["contents"] = "contents";
  Displaying2["grid"] = "grid";
  Displaying2["inlineBlock"] = "inline-block";
  Displaying2["inlineFlex"] = "inline-flex";
  Displaying2["inlineGrid"] = "inline-grid";
  Displaying2["inlineTable"] = "inline-table";
  Displaying2["listItem"] = "list-item";
  Displaying2["table"] = "table";
  Displaying2["tableCell"] = "table-cell";
  Displaying2["none"] = "none";
  return Displaying2;
})(Displaying || {});
export {
  Displaying
};
//# sourceMappingURL=displaying.es.js.map
